import { render, staticRenderFns } from "./AddingMenu.vue?vue&type=template&id=5bbc3458&"
import script from "./AddingMenu.vue?vue&type=script&lang=ts&setup=true&"
export * from "./AddingMenu.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports